import * as PIXI from 'pixi.js';
import {createGame} from "./slotBoard";
import "./slotBoard/spin";
import {store} from "./store";
import {socketService} from "./socketService";
import {updateCanvasSize} from "../App";
import {getTranslations} from "./api/translationsApi";
import {spriteSheetAssets} from "./slotBoard/spriteSheetAssets";

export const pixiComponents = {
    app: null,
    cpItems: {},
};

const assetsSources = [
    "./assets/buyFreeSpinsModalBg.webp",
    "./assets/buttonsAssets.json",
    "./assets/buyFreeSpinsBg.webp",
    "./assets/tumbleWinBoardBg.webp",
    "./assets/bonusMobileBg.webp",
    "./assets/acceptIcon.webp",
    "./assets/cancelIcon.webp",
    "./assets/mobile-bg.webp",
    "./assets/bonusBg.webp",
    "./fonts/BebasNeue.ttf",
    "./assets/board-bg.webp",
    "./assets/blue-board-bg.webp",
    "./assets/logo1.webp",
    "./assets/logo2.webp",
    "./assets/bg.webp",
    "./assets/total-multiplier-bg.webp",
];

PIXI.Assets.load(assetsSources)
    .then(() => getTranslations(store.gameId, store.languageCode))
    .then(async (translations) => {
        await spriteSheetAssets.loadSpriteSheets();
        store.setTranslations(translations.data);
        window.addEventListener('message', onMessage);
        window.parent.postMessage({event: 'game-preloaded'}, '*');
    });

const removeAstrionaLoadingBanner = () => {
    window.parent.postMessage({event: 'game-loaded'}, '*');
}

const onMessage = async (e) => {
    if (e.data.event === 'access-token-received') {
        store.setAccessToken(e.data.accessToken);

        if (pixiComponents.app) {
            return;
        }

        socketService
            .startConnection()
            .then(createGame)
            .then(() => {
                updateCanvasSize();
                removeAstrionaLoadingBanner();
            })
    }
}